<template>
  <v-container class="v-sheet-main-container brand elevation-12">
    <v-toolbar flat class="v-toolbar-custom">
      <v-toolbar-title>{{ $t('brandcontent.title') }}</v-toolbar-title>
    </v-toolbar>
        <v-sheet class="border-main-content custom-center elevation-3">
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  mounted () {

  }
}
</script>

<style scoped>
</style>
